import { Grid } from "@material-ui/core";
import React from "react";
import { useAuth } from "@ofqual/portal-core/core/hooks/useAuth";
import { authSelector } from "../redux/selectors";
import surveyData from "../services/json/survey.json";

export const Survey: React.FC = () => {

    const { userType } = useAuth(authSelector);
    const userSurvey = surveyData.find(survey => survey.userType === userType);
    return (
        <div id="feedback-banner">
            {userSurvey ? (
                <Grid container md={12} >
                    <p style={{paddingLeft: "1em"}}>
                    <span>
                    {userSurvey.contenta}
                    &nbsp;
                    <a href={userSurvey.link} style={{ color: "inherit" }} target="_blank" rel="noopener noreferrer">{userSurvey.linkText}</a> 
                    &nbsp;
                    {userSurvey.contentb}
                    </span>
                    </p>
                </Grid>
            ) : null}
        </div>
    );
};
